import { Component, OnInit } from '@angular/core';

import { AppService } from '../../../services/app.service';

import { PortfolioService } from '../../../services/portfolio.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { IPortfolioProgramCourse, IPortfolioProgramInfo, IPortfolioProgramSemester } from '../../../models/Portfolio';

interface ISemester {
    semester: IPortfolioProgramSemester;
    courses: IPortfolioProgramCourse[];
    isExpanded?: boolean;
}

interface IProgram {
    program: IPortfolioProgramInfo;
    coursesBySemester: ISemester[];
}

const cache: {
    items?: IProgram[],
    user?: string
} = {};

export function reset() {
    cache.items = undefined;
}

@Component({
    selector: 'app-portfolio-programs',
    templateUrl: './portfolio-programs.component.html',
    styleUrls: ['./portfolio-programs.component.scss']
})
export class PortfolioProgramsComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: PortfolioService
    ) { }

    programs: IProgram[] = [];
    canOpenGrades: boolean;
    canOpenEqualizations: boolean;

    readonly courseColumns: ITableColumn[] = [
        { label: 'portfolio_programs_lblBlock', width: '1px', cssClass: 'hidden-sm-down' },
        { label: 'portfolio_programs_lblCourse' },
        { label: 'portfolio_programs_lblEcts', cssClass: 'hidden-sm-down' },
        { label: 'portfolio_programs_lblGrade', cssClass: 'hidden-sm-down' },
        { width: '1px' }
    ];

    get studentId() {
        return this.app.currentUser.username.split('@')[0];
    }

    ngOnInit() {
        this.canOpenGrades = this.app.currentUser.hasRight('MARKS.MY.VIEW');
        this.canOpenEqualizations = this.app.currentUser.hasRight('COURSE_EQUALIZATION.VIEW');

        if (cache.items && cache.user == this.app.currentUser.username) {
            this.programs = cache.items;
        } else {
            this.app.addLoading(this.service.getProgramSummary()).subscribe(data => {
                const programs: IProgram[] = [];

                data.Programs.forEach(p => {
                    const courses = data.Courses.filter(t => t.ProgramId == p.Id);
                    const semesters: ISemester[] = [];

                    courses.forEach(c => {
                        const semester = data.Semesters.find(t => t.Index == c.SemesterIndex);
                        let rowSemester = semesters.find(s => s.semester.Index == semester.Index);

                        if (!rowSemester) {
                            rowSemester = {
                                semester,
                                courses: []
                            };

                            semesters.push(rowSemester);
                        }

                        rowSemester.courses.push(c);
                    });

                    semesters.sort((a, b) => a.semester.Index - b.semester.Index);

                    programs.push({
                        program: p,
                        coursesBySemester: semesters
                    });
                });

                this.programs = cache.items = programs;
                cache.user = this.app.currentUser.username;
            });
        }
    }

    getEctsDisplay(value?: number): string {
        if (value == undefined) return this.app.translate('portfolio_noData');
        else return value.toString();
    }
}
